import { useAtomValue, useSetAtom } from 'jotai';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { useIsScreenBelowBreakpoint } from '../../../hooks/useIsScreenBelowBreakpoint';
import { useTrackEvent } from '../../../segment/segment';
import { EventTypeEnum } from '../../../segment/types';
import { sessionInfoAtom } from '../../../state';
import { preSessionVibesOpenAtom } from '../../state';
import { useBackgroundMusicPlayback as defaultUseBackgroundMusicPlayback } from '../background-action/useBackgroundMusicPlayback';
import { HorizontalVibes } from './HorizontalVibes';
import { VerticalVibesWrapper as VerticalVibes } from './VerticalVibes';
import { VibesComponentProps } from './types';

type PreSessionVibesWrapperProps = {
  VerticalVibesComponent?: React.FC<VibesComponentProps>;
  HorizontalVibesComponent?: React.FC<VibesComponentProps>;
  useBackgroundMusic?: typeof defaultUseBackgroundMusicPlayback;
};
export function PreSessionVibesWrapper({
  useBackgroundMusic = defaultUseBackgroundMusicPlayback,
  VerticalVibesComponent = VerticalVibes,
  HorizontalVibesComponent = HorizontalVibes,
}: PreSessionVibesWrapperProps) {
  const { handlePause } = useBackgroundMusic();
  const { userViewed } = useTrackEvent();
  const isSmallScreen = useIsScreenBelowBreakpoint('sm');

  const { providerShortId = '', patientShortId = '' } = useParams();
  const setPreSessionVibesOpen = useSetAtom(preSessionVibesOpenAtom);

  const appointmentShortId = useAtomValue(sessionInfoAtom)?.appointment?.shortId ?? '';

  async function closePreSessionVibes() {
    handlePause();
    setPreSessionVibesOpen(false);
  }

  useEffect(() => {
    userViewed(EventTypeEnum.PRE_SESSION_VIBES, {
      patientShortId,
      providerShortId,
      appointmentShortId,
    });
  }, [providerShortId, patientShortId, appointmentShortId, userViewed]);

  if (isSmallScreen) {
    return <VerticalVibesComponent closePreSessionVibes={closePreSessionVibes} />;
  }

  return <HorizontalVibesComponent closePreSessionVibes={closePreSessionVibes} />;
}
